import { enableProdMode, provideAppInitializer, inject, ErrorHandler, importProvidersFrom } from '@angular/core';
import { environment } from '@environments/environment';

import { detectCamera, getFaceTracker } from './app/app.module';
import { CameraDetectorService } from '@services/camera-detector.service';
import { FaceTracker } from '@services/face-tracker';
import { NewrelicErrorHandler } from '@services/newrelic-error-handler';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileSaverModule } from 'ngx-filesaver';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { provideMissingTranslationHandler, provideTranslateService } from '@ngx-translate/core';
import { LvMissingTranslationHandler } from '@utils/missing-translation-handler';
import { AppComponent } from './app/app.component';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { apolloProvider } from './app/providers/apollo.provider';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      NgxPaginationModule,
      FileSaverModule,
      FilterPipeModule
    ),
    provideAppInitializer(() => {
      const initializerFn = detectCamera(inject(CameraDetectorService));
      return initializerFn();
    }),
    {
      provide: FaceTracker,
      useFactory: getFaceTracker,
      deps: [CameraDetectorService]
    },
    {
      provide: ErrorHandler,
      useClass: NewrelicErrorHandler
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      missingTranslationHandler: provideMissingTranslationHandler(LvMissingTranslationHandler),
      fallbackLang: 'en',
      lang: 'en'
    }),
    provideHttpClient(),
    apolloProvider()
  ]
}).catch((err) => console.error('general boot error', err));
